import React from "react";
import { PROJECT_AWARDED_BY } from "../constant";

export const ToggleBtn = props => {
  const event = new CustomEvent("customEvent", {
    detail: { message: "check for under-maintenance" }
  });
  window.dispatchEvent(event);
  let {
    callback,
    checked = false,
    checkedTitle = PROJECT_AWARDED_BY.STATE,
    uncheckedTitle = PROJECT_AWARDED_BY.CENTRAL,
    central,
    state,
    name,
    id
  } = props;

  const newId = id === undefined ? "a" : id;
  return (
    <div className="can-toggle">
      <input
        id={newId}
        type="checkbox"
        checked={checked}
        onChange={e => callback(e)}
        name={name}
      />
      <label htmlFor={newId}>
        {central ? (
          <span className="notify-count" style={{ left: "10px" }}>
            {central > 99 ? "99+" : central}
          </span>
        ) : null}
        {state ? (
          <span className="notify-count" style={{ right: "10px" }}>
            {state > 99 ? "99+" : state}
          </span>
        ) : null}
        <div
          data-test="state-and-central-toggle-switch"
          className="can-toggle__switch"
          data-checked={checkedTitle}
          data-unchecked={uncheckedTitle}
        />
      </label>
    </div>
  );
};
